import React, { useState } from 'react';
import DeptInput from './DebtInput'
import PayoffOutput from './PayoffOutput'
import { payoffOrder } from '../consts'
import { calcDebtPayoff } from '../libs/finCalcs'

// material UI
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button'
import { isFlowBaseAnnotation } from '@babel/types';
import { makeStyles } from '@material-ui/core/styles';

const INPUT = false;
const SCHEDULE = true;

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    tableWrapper: {
        maxHeight: 440,
        overflow: 'auto',
    },
});

function DebtPayoffCalc(props) {

    const classes = useStyles();

    const [mode, setMode] = useState(INPUT)
    const [debts, setDebts] = useState([
        {
            debtName: "cc",
            balance: 1000,
            rate: 1,
            payment: 100
        },
        {
            debtName: "visa",
            balance: 4000,
            rate: 2,
            payment: 200
        }
    ])
    const [orderChoice, setOrderChoice] = useState(payoffOrder.ENTRY_ORDER)

    let schedules = {} // holds payoff and summary schedules

    if (mode === SCHEDULE) {

        schedules = calcDebtPayoff(debts, orderChoice)
    }
    const switchMode = () => {

        setMode(!mode)
    }

    const handleChangeOrder = event => {
        setOrderChoice(event.target.value)
        schedules = calcDebtPayoff(debts, event.target.value)
    }

    return (
        <div>
            <p>Debt Payoff Calculator</p>
            <Button
                style={{ marginRight: "8px" }}
                color='primary'
                variant="contained"
                onClick={switchMode}
            >
                {
                    mode !== INPUT ? (
                        "Manage Debts"
                    ) : (
                            "Get Payoff Schedule"
                        )
                }
            </Button>
            {
                mode === INPUT ? (
                    <React.Fragment>
                        {/* <Button
                            color='primary'
                            variant="contained"
                        >
                            Save To Account
                        </Button> */}

                        <DeptInput switchMode={switchMode} debts={debts} setDebts={setDebts}></DeptInput>
                    </React.Fragment>
                ) : (
                        <React.Fragment>
                            <FormControl variant="filled" className={classes.formControl}>
                                <InputLabel id="demo-simple-select-autowidth-label">Payoff Order</InputLabel>
                                <Select
                                    labelid="demo-simple-select-autowidth-label"
                                    id="demo-simple-select-autowidth"
                                    value={orderChoice}
                                    onChange={handleChangeOrder}
                                    autoWidth
                                >
                                    <MenuItem value={payoffOrder.ENTRY_ORDER}>As Entered</MenuItem>
                                    <MenuItem value={payoffOrder.HIGH_INTEREST_FIRST}>Highest Interst First</MenuItem>
                                    <MenuItem value={payoffOrder.LOW_BAL_FIRST}>Lowest Balance First</MenuItem>
                                </Select>
                            </FormControl>
                            <PayoffOutput schedules={schedules} switchMode={switchMode} debts={debts}></PayoffOutput>
                        </React.Fragment>
                    )
            }
        </div>
    );
}

export default DebtPayoffCalc;